<!-- Section A: Selección de Booking -->
<div class="section-card" [formGroup]="form">
    <div class="section-header">
        <mat-icon>bookmark</mat-icon>
        Selección de Booking
    </div>

    <div class="section-body">
        <div class="booking-selection-row">
            <mat-form-field appearance="outline" class="booking-field booking-col">
                <mat-label>Booking (OPB)</mat-label>
                <input
                    matInput
                    [formControl]="bookingInputCtrl"
                    [matAutocomplete]="bookingAuto"
                    (input)="onBookingSearchInput()"
                    (blur)="onBookingInputBlur()"
                    placeholder="Buscar por Nro reserva"
                />
                <mat-autocomplete
                    #bookingAuto="matAutocomplete"
                    [displayWith]="displayBookingSummaryForAutocomplete"
                    (optionSelected)="onBookingSelected($event)"
                >
                    <mat-option
                        *ngFor="let booking of filteredBookings"
                        [value]="booking"
                    >
                        {{ booking.carrierBookingNumber || booking.bookingNumber }} ({{
                            booking.customerName
                        }}) — {{ booking.containerCount }} contenedores<ng-container *ngIf="booking.pendingContainerCount !== null"> ({{ booking.pendingContainerCount }} pend.)</ng-container>
                        <span *ngIf="booking.hasActiveShippingInstruction">
                            (+ instructivo existente)</span
                        >
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="outline" class="booking-field exporter-col">
                <mat-label>Cliente</mat-label>
                <input
                    matInput
                    [formControl]="exporterFromBookingCtrl"
                    readonly
                    placeholder="Nombre del cliente (portal)"
                    autocomplete="off"
                />
            </mat-form-field>
        </div>
        <!--
            Ref. Cliente pasó a ser por-instructivo (Step 3, feat-ie-wizard-mejoras punto 2):
            antes vivía acá como campo único a nivel de booking.
        -->


        <div
            class="alert-banner alert-info external-booking-hint"
            *ngIf="showNonOpbBookingHint"
        >
            <mat-icon>info_outline</mat-icon>
            <span>
                Si continúa sin un booking OPB, deberá completar los datos de las
                organizaciones manualmente.
            </span>
        </div>

        <div class="actions" *ngIf="showApplyBookingButton">
            <button
                mat-raised-button
                color="primary"
                (click)="applyBooking()"
                [disabled]="isLoading"
            >
                <mat-icon *ngIf="!isLoading">check</mat-icon>
                <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
                Aplicar Booking
            </button>
        </div>

        <!-- Warning: Booking ya tiene instructivo -->
        <mat-card *ngIf="blockingWarning" class="warning-card mt-3">
            <mat-card-content>
                <mat-icon class="warning-icon">warning</mat-icon>
                <span>{{ blockingWarning }}</span>
            </mat-card-content>
        </mat-card>

        <!-- Confirmation: solo booking OPB aplicado vía API -->
        <mat-card
            *ngIf="bookingApplied && !blockingWarning && isOpbBooking"
            class="success-card mt-3"
        >
            <mat-card-content>
                <mat-icon class="success-icon">check_circle</mat-icon>
                <span
                    >✓ Booking aplicado. Datos precargados
                    automáticamente.</span
                >
            </mat-card-content>
        </mat-card>

    </div>
</div>

<!-- Section B: Organizaciones (3 columnas) — el control shipperName existe siempre en el formulario. -->
<div class="section-card" *ngIf="form.get('shipperName')">
    <div class="section-header">
        <mat-icon>business</mat-icon>
        Organizaciones
    </div>

    <div class="section-body">
        <form [formGroup]="form">
            <div class="parties-grid">
                <!-- Shipper (Exportador) -->
                <div class="party-column">
                    <h3>
                        Exportador (Shipper) <span class="required">*</span>
                    </h3>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Seleccionar Exportador</mat-label>
                        <input
                            matInput
                            formControlName="shipperName"
                            [matAutocomplete]="shipperAuto"
                            (focus)="
                                searchParties(
                                    'shipper',
                                    $any($event.target).value || ''
                                )
                            "
                            (input)="
                                searchParties(
                                    'shipper',
                                    $any($event.target).value || ''
                                )
                            "
                        />
                        <mat-autocomplete #shipperAuto="matAutocomplete">
                            <mat-option
                                *ngFor="let option of shipperOptions"
                                [value]="
                                    (option.shortName || option.name || '').trim()
                                "
                                (onSelectionChange)="
                                    onPartyOptionSelectionChange(
                                        $event,
                                        'shipper',
                                        option
                                    )
                                "
                            >
                                {{
                                    (option.shortName || option.name || '').trim()
                                }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>

                    <mat-form-field
                        appearance="outline"
                        class="full-width"
                        *ngIf="selectedShipper"
                    >
                        <mat-label>Dirección</mat-label>
                        <input
                            matInput
                            formControlName="shipperAddress"
                            readonly
                        />
                    </mat-form-field>
                </div>

            </div>
        </form>
    </div>
</div>

<div class="alert-banner alert-info" *ngIf="isOpbBooking">
    <mat-icon>info_outline</mat-icon>
    <span>Booking OPB: los datos del Exportador se precargaron automáticamente; puede editarlos.
        El Consignatario y Notificante se asignan por instructivo en el paso 3.</span>
</div>
